// extracted by mini-css-extract-plugin
export default {"container":"g__container--YCltB","flex-child":"g__flex-child--eXnBa","success":"g__success--eHD4L","info":"g__info--awq58","caution":"g__caution--AugEp","gray":"g__gray--nsOdC"};